import CloseIcon from "@mui/icons-material/Close";
import { DialogActions } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";

import useI18N from "../hooks/useI18N";

const MUIDialog = styled(Dialog)(({ theme, maxWidth, dir, maxHeight }) => {
  // If maxWidth is a number, use it as px and do not apply breakpoints
  if (typeof maxWidth === "number") {
    return {
      "& .MuiDialogContent-root": { padding: theme.spacing(2), fontSize: 14 },
      "& .MuiDialogActions-root": { padding: theme.spacing(1) },
      "& .MuiPaper-root": {
        width: "100%",
        margin: 16,
        ...(maxHeight ? { maxHeight: maxHeight } : {}),
        maxWidth: maxWidth,
      },
      "& .MuiDialogTitle-root": {
        fontSize: 16,
      },
      "& .MuiIconButton-close": {
        left: dir === "rtl" ? 8 : "unset",
        right: dir === "rtl" ? "unset" : 8,
      },
    };
  }
  return {
    "& .MuiDialogContent-root": { padding: theme.spacing(2), fontSize: 14 },
    "& .MuiDialogActions-root": { padding: theme.spacing(1) },
    "& .MuiPaper-root": {
      width: "100%",
      margin: 16,
      ...(maxHeight ? { maxHeight: maxHeight } : {}),
      ...(maxWidth ? { maxWidth: maxWidth } : {}),
      [theme.breakpoints.down("sm")]: {
        maxWidth: 350,
        minWidth: 0,
        margin: 8,
      },
      [theme.breakpoints.between("sm", "md")]: {
        maxWidth: 500,
      },
      [theme.breakpoints.up("md")]: {
        maxWidth: 600,
      },
    },
    "& .MuiDialogTitle-root": {
      fontSize: 16,
    },

    "& .MuiIconButton-close": {
      left: dir === "rtl" ? 8 : "unset",
      right: dir === "rtl" ? "unset" : 8,
    },
  };
});

export default function MUIModal({
  open,
  title,
  titleSx,
  content,
  maxWidth,
  maxHeight,
  actionPallet,
  handleClose,
  fullWidth = "md",
}) {
  const { dir } = useI18N();
  return (
    <MUIDialog
      {...{
        dir,
        open,
        maxWidth,
        maxHeight,
        fullWidth,
        onClose: handleClose,
        "aria-labelledby": "customized-dialog-title",
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, ...titleSx }} id="customized-dialog-title">
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        className="MuiIconButton-close"
        sx={(theme) => ({
          position: "absolute",
          top: 8,
          right: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      {content}
      {actionPallet && <DialogActions>{actionPallet}</DialogActions>}
    </MUIDialog>
  );
}
